import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { AppService, Types } from '../../../App/Services/AppService';
import HistoricalRealisedGainOrLossReportCriteria from './HistoricalRealisedGainOrLossReportCriteria';

@NeoReport("HistoricalRealisedGainOrLoss", { category: MaintenanceReportCategories.DataValidationReports })
export default class HistoricalRealisedGainOrLossReport extends Report<HistoricalRealisedGainOrLossReportCriteria> {
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(HistoricalRealisedGainOrLossReportCriteria);
    }

    public renderCriteria() {
        return (
            <>
                <Neo.GridLayout lg={3} md={3}>
                    <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName}
                        label={TextConstants.Labels.Broker}>
                        <Neo.AutoCompleteDropDown
                            itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                            bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                            bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                            displayMember={"serviceProviderGroupingName"}
                            items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                                .sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                        />
                    </Neo.FormGroup>
                    <Neo.FormGroup 
                        bind={this.criteria.meta.brokerAccount} />
                    <Neo.FormGroup
                        appendText="fa-calendar"
                        bind={this.criteria.meta.startDate} />
                    <Neo.FormGroup 
                        appendText="fa-calendar"
                        bind={this.criteria.meta.endDate} />
                    <Neo.FormGroup 
                        bind={this.criteria.meta.gainPercentageThreshold} />
                    <Neo.FormGroup 
                        bind={this.criteria.meta.lossPercentageThreshold} />
                </Neo.GridLayout>
            </>
        );
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}